import { useState, useEffect } from "react";
import api from "./api";
import "./App.css";
import { useLocation, useNavigate } from "react-router-dom";

export default function EditDevData() {
  const location = useLocation();
  const navigate = useNavigate();

  const { devId } = location.state || {};

  const [groupedData, setGroupedData] = useState({});
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    DU: "",
    ALDS: "",
    DI: "",
    mqtt: ""
  });

  /* ---------------- LOAD CONFIG ---------------- */
  useEffect(() => {
    const loadConfig = async () => {
      setLoading(true);
      setError("");

      try {
        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/login");
          return;
        }

        const res = await api.get("/api/config", {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        const grouped = res.data.reduce((acc, item) => {
          if (!acc[item.devHead]) acc[item.devHead] = [];
          acc[item.devHead].push(item.devDtls);
          return acc;
        }, {});

        setGroupedData(grouped);
      } catch (err) {
        console.error(err);
        setError("Failed to load configuration");

        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/login");
        }
      } finally {
        setLoading(false);
      }
    };

    loadConfig();
  }, [navigate]);

  /* ---------------- SUBMIT UPDATE ---------------- */

const handleSubmit = async () => {
  try {
    if (!formData.DU || !formData.ALDS || !formData.DI) {
      setError("Please select all fields before updating");
      return;
    }

    if (!devId) {
      setError("Invalid device ID");
      return;
    }

    const token = localStorage.getItem("token");
    const username = localStorage.getItem("username");

    if (!token) {
      setError("Session expired. Please login again.");
      navigate("/login");
      return;
    }

    setLoading(true);

    const payload = {
      deviceId: devId,
      devDU: formData.DU,
      devAdls: formData.ALDS,
      devDi: formData.DI,
      mqtt: formData.mqtt,
      user: username
    };

    const res = await api.post("/api/updateDevData", payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    console.log("Update response:", res.data);
    if (res.data.affectedRows === 0) {
      setError("No changes detected. Nothing updated.");
      return;
    }

    alert("Device updated successfully");
    navigate("/searchdev");

  } catch (err) {
    console.error(err);
    setError("Update failed");
  } finally {
    setLoading(false);
  }
};


  /* ---------------- UI ---------------- */
  return (
    <div className="App-header">
      <h3>Device ID Configuration</h3>

      {loading && <p>Loading configuration…</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      <table>
        <tbody>
          <tr>
            <td>Device ID:</td>
            <td>{devId}</td>
          </tr>

          {["DU", "ALDS", "DI"].map((head) => (
            <tr key={head}>
              <td>{head}:</td>
              <td>
                <select
                  value={formData[head]}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      [head]: e.target.value
                    }))
                  }
                >
                  <option value="">Select</option>
                  {groupedData[head]?.map((val, idx) => (
                    <option key={idx} value={val}>
                      {val}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          ))}

          <tr>
            <td>MQTT Status:</td>
            <td>
              <input
                value={formData.mqtt}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    mqtt: e.target.value
                  }))
                }
              />
            </td>
          </tr>
        </tbody>
      </table>

      <button onClick={handleSubmit}>Update</button>
    </div>
  );
}